export const home = "/home";
export const aboutMe = "/aboutMe";
export const projects = "/projects";
export const contacts = "/contacts";
export const root = "/";